import React, { useEffect, useState } from 'react'
import ModalCustom from '../../../../modal-custom'
import { Button, Col, Form, Row } from 'react-bootstrap'
import LabelCustom from '../../../../label-custom'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import Autocomplete from '../../../../custom/autocomplete'
import UseLeaveUserType from '../../../../../hooks/use-leave-user-type'
import { postLeaveTypeAPI } from '../../../../../services/welfare-leave'
import SwalCustom from '../../../../../alert/swal-custom'
import Swal from 'sweetalert2'
import { TXTSUCCESS } from '../../../../../Constants'
import Error_false from '../../../../error/error-false'

const schema = yup
  .object({
    leaveType: yup.object().required('Please, choose your leave type'),
    leaveTotal: yup.string().required('Please, input your total'),
    leaveUsed: yup.string().required('Please, Choose your used')
  })
  .required()

export default function ModalLeaveAdd({
  handleModalAddClose,
  showModalAddOpen,
  isModalOpen,
  isSave,
  setIsSave,
  orgId,
  code,
  getLeave,
  handleKeyDownNum
}) {
  const {
    control,
    setError,
    setValue,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  const leaveType = UseLeaveUserType({ orgId, code, isModalOpen })
  const [total, setTotal] = useState()

  useEffect(() => {
    setValue('leaveTotal', total)
  }, [total])

  const onSubmit = (d) => {
    const body = {
      orgId,
      code,
      leaveTypeId: d?.leaveType?.value,
      total: parseFloat(d?.leaveTotal),
      used: parseFloat(d?.leaveUsed)
    }
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to create new?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        createLeave(body)
      }
    })
  }

  const createLeave = async (body) => {
    const res = await postLeaveTypeAPI(body)
    setIsSave(false)
    if (!res) {
      setIsSave(false)
      return
    }
    if (res.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        getLeave()
        Swal.close()
      })
    } else {
      Error_false(res)
    }

    setIsSave(false)
    handleModalAddClose()
  }
  return (
    <ModalCustom
      width={500}
      open={showModalAddOpen}
      onCancel={handleModalAddClose}
    >
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-3 row"
        style={{ rowGap: '13px' }}
      >
        <label>Add Leave</label>

        <Col md={12}>
          <LabelCustom text={'Leave Type'} />
          <Controller
            name={'leaveType'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <>
                <Autocomplete
                  options={leaveType}
                  onChange={(value) => {
                    onChange(value)
                    setValue('leaveType', value)
                    setTotal(value?.total)
                  }}
                  value={value}
                />
              </>
            )}
          />
          {errors.leaveType?.message && (
            <label className="small text-danger">
              {errors.leaveType.message}
            </label>
          )}
        </Col>
        <Col md={12}>
          <Row>
            <Col xl={6}>
              <LabelCustom text={'Total'} />
              <Controller
                name={'leaveTotal'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <>
                    <Form.Control
                      value={value}
                      type="number"
                      onChange={onChange}
                      onKeyDown={handleKeyDownNum}
                    />
                  </>
                )}
              />
              {errors.leaveTotal?.message && (
                <label className="small text-danger">
                  {errors.leaveTotal.message}
                </label>
              )}
            </Col>
            <Col xl={6}>
              <LabelCustom text={'Used'} />
              <Controller
                name={'leaveUsed'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <>
                    <Form.Control
                      type="number"
                      value={value}
                      onChange={onChange}
                      onKeyDown={handleKeyDownNum}
                    />
                  </>
                )}
              />
              {errors.leaveUsed?.message && (
                <label className="small text-danger">
                  {errors.leaveUsed.message}
                </label>
              )}
            </Col>
          </Row>
        </Col>
        <Col xl={12} className="text-center mt-4">
          <Button
            className="px-4 me-2 bg-secondary text-white"
            size="sm"
            variant="light"
            type="button"
            // disabled={isSave}
            onClick={handleModalAddClose}
          >
            Close
          </Button>
          <Button type="submit" className="px-4" disabled={isSave} size="sm">
            {isSave ? 'Saving...' : 'Save'}
          </Button>
        </Col>
      </Form>
    </ModalCustom>
  )
}
